import * as React from "react";
import { useTranslation } from "react-i18next";

import ApplicationLayout from "components/layout/ApplicationLayout";
import { WORKFLOWS_ROUTE } from "components/router/Routes";
import WorkflowTemplateCardView from "components/workflows/workflow-templates/WorkflowTemplateCardView";
import { workflowService } from "services/workflows/WorkflowService";

export default function WorkflowTemplateView(): JSX.Element {
    const { t } = useTranslation();
    const [count, setCount] = React.useState<number>(0);
    return (
        <>
            <ApplicationLayout
                viewTitle={t("Routes.workflowTemplates")}
                view={
                    <WorkflowTemplateCardView
                        search=""
                        workflowService={workflowService}
                        count={count}
                        setCount={setCount}
                    />
                }
                mainRoute={WORKFLOWS_ROUTE}
            />
        </>
    );
}
